export default __webpack_public_path__ + "static/media/sh_4.0022494a.png";